import { render } from "./implementing-stairs-in-2d-top-down-games.vue?vue&type=template&id=9302cc02"
import script from "./implementing-stairs-in-2d-top-down-games.vue?vue&type=script&lang=ts"
export * from "./implementing-stairs-in-2d-top-down-games.vue?vue&type=script&lang=ts"
script.render = render

export default script